import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, ReactNode } from 'react';
import { ReactiveMotionDiv } from '@/components/ReactiveMotionDiv';
import { cn } from '@/lib/cn';
export interface GradientCardProps extends ComponentProps<typeof ReactiveMotionDiv> {
  color: 'primary' | 'secondary';
  shade: 'light' | 'mid' | 'dark';
  children?: ReactNode;
  className?: string;
}
export function GradientCard(t0) {
  const $ = _c(18);
  let children;
  let className;
  let color;
  let props;
  let shade;
  if ($[0] !== t0) {
    ({
      shade,
      children,
      className,
      color,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = color;
    $[4] = props;
    $[5] = shade;
  } else {
    children = $[1];
    className = $[2];
    color = $[3];
    props = $[4];
    shade = $[5];
  }
  const t1 = color === "primary" && shade === "light";
  const t2 = color === "primary" && shade === "mid";
  const t3 = color === "primary" && shade === "dark";
  const t4 = color === "secondary" && shade === "light";
  const t5 = color === "secondary" && shade === "mid";
  const t6 = color === "secondary" && shade === "dark";
  let t7;
  if ($[6] !== className || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = cn("rounded-2xl md:rounded-4xl text-white card-shadow", className, {
      "primary-card-gradient-light": t1,
      "primary-card-gradient-mid": t2,
      "primary-card-gradient-dark": t3,
      "secondary-card-gradient-light": t4,
      "secondary-card-gradient-mid": t5,
      "secondary-card-gradient-dark": t6
    });
    $[6] = className;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children || $[15] !== props || $[16] !== t7) {
    t8 = <ReactiveMotionDiv className={t7} {...props}>{children}</ReactiveMotionDiv>;
    $[14] = children;
    $[15] = props;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}